/**
 * Development-only synthetic main-thread pressure for the React parent.
 * Production builds never start this harness, even if sessionStorage is set.
 */

import { isSimPressureAllowed, pressureForProfile, normalizeSimProfile, ENVELOPE_SIM_PROFILES } from './voiceBotEnvelopeConfig';

let rafId = 0;
let running = false;
let busyMs = 0;
let intervalMs = 16;
let lastPulse = 0;
let appliedMs = 0;
let pulseCount = 0;

function spin(ms) {
  const end = performance.now() + ms;
  while (performance.now() < end) {
    /* busy-wait: intentional, development-only */
  }
}

function pulse(now) {
  if (!running) return;
  if (busyMs <= 0) {
    rafId = requestAnimationFrame(pulse);
    return;
  }
  if (now - lastPulse >= intervalMs) {
    lastPulse = now;
    spin(busyMs);
    appliedMs += busyMs;
    pulseCount++;
  }
  rafId = requestAnimationFrame(pulse);
}

export function startVoiceBotSimHarness(profile) {
  stopVoiceBotSimHarness();
  if (!isSimPressureAllowed()) return { started: false, reason: 'production-or-non-local' };
  const next = normalizeSimProfile(profile);
  const pressure = pressureForProfile(next);
  busyMs = pressure.busyMs;
  intervalMs = pressure.intervalMs;
  if (next === ENVELOPE_SIM_PROFILES.OFF || busyMs <= 0) {
    return { started: false, reason: 'no-pressure', profile: next, busyMs, intervalMs };
  }
  running = true;
  lastPulse = 0;
  appliedMs = 0;
  pulseCount = 0;
  rafId = requestAnimationFrame(pulse);
  return { started: true, profile: next, busyMs, intervalMs };
}

export function stopVoiceBotSimHarness() {
  running = false;
  if (rafId) cancelAnimationFrame(rafId);
  rafId = 0;
}

export function getVoiceBotSimStatus() {
  return {
    running,
    busyMs,
    intervalMs,
    appliedMs: Math.round(appliedMs * 100) / 100,
    pulseCount,
  };
}

export function postSimPressureToIframe(win, targetOrigin, profile) {
  if (!win || !targetOrigin || !isSimPressureAllowed()) return false;
  const pressure = pressureForProfile(profile);
  try {
    win.postMessage(
      {
        type: 'VB_SIM_PRESSURE',
        busyMs: pressure.busyMs,
        intervalMs: pressure.intervalMs,
      },
      targetOrigin
    );
    return true;
  } catch {
    return false;
  }
}
